(function() {
    function getCookie(name) {
      let value = "; " + document.cookie;
      let parts = value.split("; " + name + "=");
      if (parts.length === 2) {
        return parts.pop().split(";").shift();
      }
    }
  
    document.addEventListener('DOMContentLoaded', function() {
      let overlayCart = document.querySelector('div.overlay-cart');
  
      if (!getCookie('cart_alert')) {
        overlayCart.style.display = 'block';
      } else {
        overlayCart.style.display = 'none';
      }
  
      function closeOverlayCart() {
        overlayCart.style.display = 'none';
  
        if (!getCookie('cart_alert')) {
          document.cookie = 'cart_alert=1; expires=7; path=/';
        }
      }
  
      overlayCart.addEventListener('click', function(event) {
        if (event.target === overlayCart) {
          closeOverlayCart();
        }
      }); 
  
      document.querySelector('div.overlay-cart a.tap-to-close').addEventListener('click', closeOverlayCart);
    });
  })();
  